import { Typography, Box, Link as MUILink } from '@mui/material';

type MemberDetailLinkProps = {
  icon?: React.ReactNode;
  linkPrefix: string;
  details: string[] | undefined;
  small?: boolean;
  endIcon?: React.ReactNode;
};

export const MemberDetailLink = (props: MemberDetailLinkProps) => {
  const { icon = undefined, linkPrefix, details, small = false, endIcon = undefined } = props;
  const nonEmptyDetails = details ? details.filter((detail) => detail !== '') : [''];
  const countDetails = nonEmptyDetails === undefined ? 0 : nonEmptyDetails.length;
  return (
    (countDetails > 0 && (
      <Typography
        variant={small ? 'body2' : 'body1'}
        component='div'
        sx={{ display: 'flex', alignItems: 'center', '& .MuiSvgIcon-root': { fontSize: small ? '0.9rem' : 'inherit' } }}
      >
        {icon}
        {countDetails === 1 && <MUILink href={`${linkPrefix}${nonEmptyDetails[0]}`}>{nonEmptyDetails[0]}</MUILink>}
        {countDetails > 1 &&
          nonEmptyDetails &&
          nonEmptyDetails.flatMap((det, i) => [
            ...(i
              ? [
                  <Box sx={{ pr: 1 }} key={det}>
                    ,{' '}
                  </Box>,
                ]
              : []),
            <MUILink href={`${linkPrefix}${det}`} key={det}>
              {det}
            </MUILink>,
          ])}
        {endIcon}
      </Typography>
    )) || <></>
  );
};
